export default __webpack_public_path__ + "static/media/boccia.075b3cf4.svg";